import { render, staticRenderFns } from "./DeliveryDurationBarChart.vue?vue&type=template&id=50e5bece&lang=pug&"
import script from "./DeliveryDurationBarChart.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDurationBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryDurationBarChart.vue?vue&type=style&index=0&id=50e5bece&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports